export const mapSettings = (state = {}, action) => {
  switch (action.type) {
    case 'SET_MAP_SETTINGS': {
      const { id, settings } = action.payload;
      return {
        ...state,
        [id]: {
          ...(state[id] || {}),
          ...settings,
        },
      };
    }
    default:
      return state;
  }
};
